/** @prettier */

import Grid from '@mui/material/Grid';
import {ChangeEvent, useState} from 'react';
import {useTranslation} from 'react-i18next';

//Style import
import '../css/common/common.css';

import {limit} from '../define';

/**
 * 画像アップロード用ボタン
 * @param props props
 * @returns JSX
 *
 * - setIsError エラーフラグ（set関数）
 * - setUploadBtnDisabled UPLOADボタン非表示フラグ（set関数）
 * - setImageFunc レイアウト画像を変数に格納する関数
 * - id 適用するID
 * - class 適用するクラス
 */
const ImageUploadButton = (props: {
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
  setUploadBtnDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  setImageFunc: (image: File) => void;
  id?: string;
}) => {
  const trans = useTranslation().t; //翻訳関数

  const [imageName, setImageName] = useState<string>(''); //画像の名前

  const onImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.setIsError(false);

    if (event.currentTarget.files === null) {
      return;
    }
    const file = event.currentTarget.files[0];
    if (file === null) {
      return;
    }
    //ファイルサイズの確認
    if (file.size / 1024 > limit.UPLOAD_FILE_SIZE_MAX) {
      props.setIsError(true);
      props.setUploadBtnDisabled(true);
    }

    props.setImageFunc(file);
    setImageName(file.name);
  };

  return (
    <Grid container columnSpacing={1} alignItems="center">
      <Grid item xs="auto">
        <label className="fileUploadButton">
          <input
            type="file"
            accept="image/png, image/jpeg"
            onChange={onImageChange}
            style={{display: 'none'}}
            id={props.id}
          />
          {trans('FileUploadButton.dialogBox.buttonTxt.selectFile')}
        </label>
      </Grid>
      <Grid item xs>
        {imageName}
      </Grid>
    </Grid>
  );
};

/**
 * CSVアップロード用ボタン
 * @param props props
 * @returns JSX
 *
 * - setCSVFunc CSVを変数に格納する関数
 * - id 適用するID
 * - class 適用するクラス
 */
const CSVUploadButton = (props: {
  setCSVFunc: (csv: File) => void;
  id?: string;
}) => {
  const trans = useTranslation().t; //翻訳関数

  const [csvName, setCSVName] = useState<string>(''); //CSVの名前

  const onCSVChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (
      event.currentTarget.files === null ||
      event.currentTarget.files[0] === null ||
      event.currentTarget.files.length === 0
    ) {
      return;
    }

    const file = event.currentTarget.files[0];
    props.setCSVFunc(file);
    setCSVName(file.name);
    event.target.value = '';
  };

  return (
    <Grid container columnSpacing={1} alignItems="center">
      <Grid item xs="auto">
        <label className="fileUploadButton">
          <input
            type="file"
            accept="text/csv"
            onChange={onCSVChange}
            style={{display: 'none'}}
            id={props.id}
          />
          {trans('FileUploadButton.dialogBox.buttonTxt.selectFile')}
        </label>
      </Grid>
      <Grid item xs>
        {csvName}
      </Grid>
    </Grid>
  );
};

export default ImageUploadButton;
export {CSVUploadButton};
